import { endpoints } from '../endpoints'
import { http } from '../http'
import { Case } from '../../types'

export const cases = {
  load: (caseID: string): Promise<Case> => http.get(endpoints.case(caseID)),
}
